import axios, { AxiosInstance } from "axios";
import ENV from "../config/env";

class HealthCheckAPI {
  adm: AxiosInstance;
  constructor() {
    this.adm = axios.create({
      baseURL: ENV.HEALTH_CHECK_API,
    });
    this.adm.interceptors.request.use(
      async (config: any) => {
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );
  }

  get(url: string) {
    const URL = url;
    return this.adm.get(URL);
  }
  post(url: string, params?: any) {
    return this.adm.post(url, params);
  }
}

export default new HealthCheckAPI();
